import React from "react";
import InexCard from "../InexCard";
import { Box, Divider, Grid, styled, Typography } from "@mui/material";
import { useIsMobile } from "../../hooks/responsive";
import SubscriptionTypeIcon from "./SubscriptionTypeIcon";

import earthIcon from "../../resources/images/svg/subscriptionChoice/earth@1,5x.svg";
import appIcon from "../../resources/images/svg/subscriptionChoice/smartphoneSVG@1,5x.svg";
import tvIcon from "../../resources/images/svg/subscriptionChoice/videos.svg";
import magIcon from "../../resources/images/svg/subscriptionChoice/magazine.svg";
import newsIcon from "../../resources/images/svg/subscriptionChoice/articles.svg";
import podcastIcon from "../../resources/images/svg/subscriptionChoice/podcast.svg";
import InexSwitch from "./InexSwitch";
import PriceFormater from "../PriceFormater";
import {getTunnel} from "../../store/reducers/subscribeSlice";
import {useSelector} from "react-redux";

const Container = styled(Box)(({ theme }) => {
	const isMobile = useIsMobile();
	return {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		height: "100%",
		flexWrap: "wrap",
		paddingTop: theme.spacing(isMobile ? 0 : 1),
		paddingBottom: theme.spacing(isMobile ? 0 : 2),
	};
});

const SubscriptionTypeCard = ({ obj, selected = false, disabled, onClick, ...props }) => {

	const isMobile = useIsMobile();

	const isDigital = React.useMemo(() => {
		return obj.idabo === 1;
	}, obj);

	const isTV = React.useMemo(() => {
		return obj.idabo === 2;
	}, obj);

	const isMag = React.useMemo(() => {
		return obj.idabo === 3;
	}, obj);

	const isPraticien = React.useMemo(() => {
		return obj.idabo === 4;
	}, obj);


	const punchLines = React.useMemo(() => {
		if (obj.idabo === 1) return "Nos ressources numériques au prix le plus accessible";
		if (obj.idabo === 2) return "Accès TV, et pack complet des explorateurs engagés";
		if (obj.idabo === 3) return "Les 4 prochains numéros papier livrés chez vous chaque année";
		if (obj.idabo === 4) return "Le digital, la TV, et une plateforme dédiée aux praticiens";
	}, obj);

	const tunnel = useSelector(getTunnel);
	const isGiftCard = React.useMemo(() => {
		return tunnel === 1;
	}, [tunnel]);

	return (
		<InexCard
			selected={selected}
			disabled={disabled}
			sx={{
				display: obj.idabo === 1 && !selected ? "none" : "flex",
				padding: 0,
				paddingTop: 0,
				paddingBottom: 0,
				...props.sx,
			}}
			onClick={!disabled ? onClick : undefined}
			{...props}
		>
			<Grid container direction={"row"} sx={{ height: "100%" }}>
				<Grid item xs={12} sm={9} md={9} container direction={"row"} wrap={"nowrap"} alignItems={"center"}>
					<Box
						width={isMobile ? "120px" : "150px"}
						minWidth={"95px"}
						height={"100%"}
						sx={{
							backgroundColor: "rgba(22,42,65,0.03)",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<InexSwitch checked={selected} onClick={onClick} />
					</Box>
					<Box
						sx={{
							width: "100%",
							height: "100%",
							display: "flex",
							alignItems: "center",
							flexDirection: "column",
							backgroundColor: isMobile ? "rgba(22,42,65,0.03)" : undefined,
							padding: (theme) => `${theme.spacing(isMobile ? 2 : 3)} ${theme.spacing(isMobile ? 0 : 4)}`,
						}}
					>
						<Typography
							variant={"h4"}
							textAlign={"left"}
							color={"secondary"}
							sx={{
								width: "100%",
								fontFamily: "Branding Bold",
								fontSize: 24,
								paddingLeft: 1,
							}}
						>
							{obj.titre}
						</Typography>
						<Typography
							textAlign={"left"}
							color={"grey.500"}
							mt={1}
							sx={{
								width: "100%",
								height: "100%",
								fontFamily: "Branding SemiBold",
								fontSize: 16,
								paddingLeft: 1,
								paddingRight: (theme) => theme.spacing(1),
							}}
						>
							{punchLines && (
								<Typography
									sx={{
										color: (theme) => theme.palette.primary.light,
										fontFamily: "Branding Bold",
									}}
								>
									{punchLines}
								</Typography>
							)}
							{/*obj.description*/}
						</Typography>
						<Container>
							<SubscriptionTypeIcon 
							icon={<img src={magIcon} 
							alt={"magIcon"} />} 
							text={"Mag. papiers"} 
							sx={{
								width: isMobile ? "48%":  "30%",
								display: obj.papier === 1 ? "flex": "none",
								flexWrap: "wrap",
								alignItems: "center",
								flexDirection: isMobile ? "column":"row",
								justifyContent: "start",
								opacity: obj.papier === 1 ? 1 : 0,
								textDecoration:  obj.papier === 1 ? "none" : "line-through",
							}} 
							 />
							<SubscriptionTypeIcon 
							icon={<img src={podcastIcon} 
							alt={"podcastIcon"} />} 
							text={"Podcasts audios"} 
							sx={{
								width: isMobile ? "48%":  "30%",
								display: "flex",
								flexWrap: "wrap",
								alignItems: "center",
								flexDirection: isMobile ? "column":"row",
								justifyContent: "start",
								opacity: obj.mobile === 1 ? 1 : 0,
								textDecoration:  obj.mobile === 1 ? "none" : "line-through",
							}}
							/>
							<SubscriptionTypeIcon 
							icon={<img src={appIcon} 
							alt={"appIcon"} />} 
							text={"Mag. numériques"}
							sx={{
								width: isMobile ? "48%":  "30%",
								display: obj.papier !== 1 ? "flex": "none",
								flexWrap: "wrap",
								alignItems: "center",
								flexDirection: isMobile ? "column":"row",
								justifyContent: "start",
								opacity: obj.magNum === 1 ? 1 : 0,
								textDecoration:  obj.magNum === 1 ? "none" : "line-through",
							}} 
							/>
							<SubscriptionTypeIcon 
							icon={<img src={newsIcon} 
							alt={"newsIcon"} />} 
							text={"Articles"}
							sx={{
								width: isMobile ? "48%":  "30%",
								display: "flex",
								flexWrap: "wrap",
								alignItems: "center",
								flexDirection: isMobile ? "column":"row",
								justifyContent: "start",
								opacity: obj.web === 1 ? 1 : 0,
								textDecoration: obj.web === 1 ? "none" : "line-through",
							}} 
							 />
							<SubscriptionTypeIcon 
							icon={<img src={tvIcon} 
							alt={"tvIcon"} />} 
							text={"Vidéos"} 
							sx={{
								width: isMobile ? "48%":  "30%",
								display: obj.tv === 1 ? "flex" : "none",
								flexWrap: "wrap",
								alignItems: "center",
								flexDirection: isMobile ? "column":"row",
								justifyContent: "start",
								opacity: obj.tv === 1 ? 1 : 0,
								textDecoration: obj.tv === 1 ? "none" : "line-through",
							}} 
							 />
							<SubscriptionTypeIcon 
							icon={<img src={earthIcon} 
							alt={"earthIcon"} />} 
							text={"Espace praticiens"} 
							sx={{
								width: isMobile ? "48%":  "30%",
								display: obj.tv === 1 ? "flex" : "none",
								flexWrap: "wrap",
								alignItems: "center",
								flexDirection: isMobile ? "column":"row",
								justifyContent: "start",
								opacity: obj.proPra === 1 ? 1 : 0,
								textDecoration: obj.proPra === 1 ? "none" : "line-through",
							}} 
							 />
							 <SubscriptionTypeIcon 
								icon={<img src={magIcon} 
								alt={"magIcon"} />} 
								text={"Mag. papiers"} 
								sx={{
									width: isMobile ? "48%":  "30%",
									display: obj.papier !== 1 && obj.tv === 1 ? "flex": "none",
									flexWrap: "wrap",
									alignItems: "center",
									flexDirection: isMobile ? "column":"row",
									justifyContent: "start",
									opacity: 0,
									textDecoration:  obj.papier === 1 ? "none" : "line-through",
								}} 
							 />
							
						</Container>
					</Box>
					{!isMobile && (
						<Divider
							variant={"fullWidth"}
							orientation={"vertical"}
							sx={{
								height: "65%",
							}}
						/>
					)}
				</Grid>
				{/*<Grid
					item
					xs={12}
					sm={3}
					md={3}
					container
					direction={"row"}
					wrap={"nowrap"}
					alignItems={"center"}
					py={isMobile ? 3 : undefined}
				>
					<Container>
						{obj.web === 1 && <SubscriptionTypeIcon icon={<img src={earthIcon} alt={"earthIcon"} />} text={"Web"} />}
						{obj.mobile === 1 && <SubscriptionTypeIcon icon={<img src={appIcon} alt={"appIcon"} />} text={"Appli"} />}
						{obj.tv === 1 && <SubscriptionTypeIcon icon={<img src={tvIcon} alt={"tvIcon"} />} text={"TV"} />}
						{obj.papier === 1 && (
							<SubscriptionTypeIcon icon={<img src={magIcon} alt={"magIcon"} />} text={"Mag. papier"} />
						)}
					</Container>
					<Divider
						variant={"fullWidth"}
						orientation={"vertical"}
						sx={{
							height: "65%",
						}}
					/>
				</Grid>*/}
				<Grid
					item
					xs={12}
					md={3}
					sm={3}
					container
					justifyContent={"center"}
					alignItems={"center"}
					py={isMobile ? 3 : undefined}
				>
					<PriceFormater
						price={isMag ? obj.frequence.montant : obj.frequence.montant}
						period={obj.frequence.titre}
						withTitle={
							isMag && false ? (
								<Typography
									sx={{
										color: "#F3C34F",
										textAlign: "center",
										fontSize: 14,
									}}
								>
									{"Nouveau prix à partir du 1 juillet : "}
									<span style={{ fontFamily: "Branding Bold" }}>
										{`${(obj.frequence.montant + 27)/100}€ / mois `}
									</span>
									
								</Typography>
							) : (
								true
							)
						}
					/>
				</Grid>
			</Grid>
		</InexCard>
	);
};

export default SubscriptionTypeCard;
